<script setup>
const props = defineProps(['input', 'promptText'])
const emits = defineEmits(['onChange'])

function onChange(event) {
  emits('onChange', event.target.value)
}
emits('onChange',props.input)
</script>
<template>
  <div class="container">
    <div class="left">
      <p>{{ promptText }}:</p>
    </div>
    <div class="right">
      <input type="text" :value="input" @change="onChange">
    </div>
  </div>
</template>
<style scoped lang="scss">
// we want select and input to have same styles
@import "@/styles/registration.scss"; 
</style>